import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// Components
import Spinner from '../Spinner';
import { useSelector } from 'react-redux';

const propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  sidebar,
  ...rest
}) => {
  const authState = useSelector(state => state.auth);
  return (
    <Route
      {...rest}
      render={props =>
        authState.isAuthenticated ? (
          <Suspense fallback={<Spinner size="small" flow="block" />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

PrivateRoute.propTypes = propTypes;

export default PrivateRoute;
